// extracted by mini-css-extract-plugin
module.exports = {"hidden":"Variants_hidden_24aMk","text-default":"Variants_text-default_3jU1w","wrapper":"Variants_wrapper_2pDqy","button":"Variants_button_3lDqx"};